import React, { useState, useEffect } from 'react'
import { X } from 'lucide-react'

// Integer values for API (0 = all, 1 = image only, 2 = csv only)
export const DOWNLOAD_TYPE_ALL = 0
export const DOWNLOAD_TYPE_IMAGE = 1
export const DOWNLOAD_TYPE_CSV = 2

export const DOWNLOAD_TYPE_OPTIONS = [
  { value: DOWNLOAD_TYPE_ALL, label: 'すべて（画像＋CSV）' },
  { value: DOWNLOAD_TYPE_IMAGE, label: '画像のみ' },
  { value: DOWNLOAD_TYPE_CSV, label: 'CSVのみ' }
]

const DownloadTypeModal = ({ isOpen, onClose, onConfirm }) => {
  const [selectedType, setSelectedType] = useState(DOWNLOAD_TYPE_ALL)

  useEffect(() => {
    if (isOpen) {
      setSelectedType(DOWNLOAD_TYPE_ALL)
    }
  }, [isOpen])

  const handleConfirm = () => {
    onConfirm(selectedType)
    onClose()
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-testid="download-type-modal">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">ダウンロード形式を選択</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            data-testid="close-modal-button"
            aria-label="閉じる"
          >
            <X size={20} />
          </button>
        </div>

        <div className="mb-6 space-y-2">
          {DOWNLOAD_TYPE_OPTIONS.map((option) => (
            <label
              key={option.value}
              className={`flex items-center p-3 border rounded-md cursor-pointer transition-colors ${
                selectedType === option.value
                  ? 'border-blue-600 bg-blue-50'
                  : 'border-gray-200 hover:bg-gray-50'
              }`}
            >
              <input
                type="radio"
                name="downloadType"
                value={option.value}
                checked={selectedType === option.value}
                onChange={() => setSelectedType(option.value)}
                className="sr-only"
                data-testid={`download-type-option-${option.value}`}
              />
              <span className="text-sm font-medium text-gray-900">{option.label}</span>
            </label>
          ))}
        </div>

        <div className="flex items-center justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors"
            data-testid="cancel-button"
          >
            キャンセル
          </button>
          <button
            onClick={handleConfirm}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            data-testid="download-confirm-button"
          >
            ダウンロード
          </button>
        </div>
      </div>
    </div>
  )
}

export default DownloadTypeModal
